import { render, staticRenderFns } from "./RecordViewComponent.vue?vue&type=template&id=765620ae&scoped=true"
import script from "./RecordViewComponent.vue?vue&type=script&lang=js"
export * from "./RecordViewComponent.vue?vue&type=script&lang=js"
import style0 from "./RecordViewComponent.vue?vue&type=style&index=0&id=765620ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765620ae",
  null
  
)

export default component.exports